import { render, staticRenderFns } from "./FoundersModal.vue?vue&type=template&id=57d74f9e&"
import script from "./FoundersModal.vue?vue&type=script&lang=js&"
export * from "./FoundersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports